import styled from "styled-components";
import { Device, Color } from "@styles/constants";
import { LargeBodyBoldCSS } from "@styles/typography";

export const Container = styled.div`
  margin-top: 30px;
  padding-bottom: 30px;

  @media ${Device.mediumUp} {
    margin-top: 40px;
    padding-bottom: 140px;
  }

  h1 {
    text-align: left;
    margin-bottom: 20px;
  }

  blockquote {
    ${LargeBodyBoldCSS}
    border-left: 0;
    color: ${Color.blackBrand};
    padding: 30px 0;
    margin: 30px 0 0;
    border-top: 1px solid ${Color.blackBrand};
    border-bottom: 1px solid ${Color.blackBrand};

    @media ${Device.mediumUp} {
      padding: 40px 0;
      margin: 40px 0 0;
    }
  }
`;
